import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getCurrentUserDetails } from "./common/routines/user-operations";
import { routes } from "./constants/routes";

interface ProtectedProviderRouteProps {
  children: React.ReactElement;
  moduleName: string;
  fallbackPath?: string;
}

const ProtectedProviderRoute = ({
  children,
  moduleName,
  fallbackPath = "/unauthorized",
}: ProtectedProviderRouteProps) => {
  const location = useLocation();

  const provider = getCurrentUserDetails("provider");
  const isAuthenticated =
    !!provider?.accessToken &&
    (!!provider?.expiryTime ? provider.expiryTime > Date.now() : true);

  if (!isAuthenticated) {
    return (
      <Navigate
        to={routes.PROVIDER_LOGIN}
        state={{ from: location }}
        replace
      />
    );
  }

  return children;
};

export default ProtectedProviderRoute;
